<ng-container *ngIf="medicalTeam.length">
    <h3>Patient Medical Team</h3>
    <mat-list class="full-width">
        <mat-list-item class="auto-height" *ngFor="let member of medicalTeam">
            <div class="icd-item">
                <div class="icd-details">
                    <p matLine class="icd-title">{{member.title}} {{member.name}} {{member.surname}}</p>
                    <p matLine class="icd-score">{{member.email}}</p>
                </div>
                <div class="view-icon">
                    <button mat-icon-button color="primary" *ngIf="canAddTeamMember(member.email)"
                        matTooltip="Add this provider to the recipient list" (click)="addTeamMember($event, member)">
                        <mat-icon>library_add</mat-icon>
                    </button>
                </div>
            </div>
        </mat-list-item>
    </mat-list>
</ng-container>

<div class="field-row m-t-20">
    <mat-form-field appearance="outline">
        <mat-label>Name</mat-label>
        <input matInput [formControl]="colleagueName" [matAutocomplete]="auto" (blur)="checkAddColleague()" />
        <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectColleague($event.option.value)">
            <mat-option *ngFor="let colleague of filteredColleagues$ | async" [value]="colleague">
                {{ colleague.title }} {{colleague.name}} {{colleague.surname}}
            </mat-option>
        </mat-autocomplete>
    </mat-form-field>

    <mat-form-field appearance="outline">
        <mat-label>Email Address</mat-label>
        <input matInput [formControl]="colleagueEmail" type="email" (blur)="checkAddColleague()">
    </mat-form-field>
</div>

<mat-form-field class="full-width m-t-20" appearance="outline">
    <mat-label>Recipient List</mat-label>
    <mat-chip-grid #chipGrid>
        <mat-chip-row *ngFor="let recipient of recipientList">
            {{ recipient.email }}
            <button matChipRemove (click)="removeRecipient(recipient)">
                <mat-icon>cancel</mat-icon>
            </button>
        </mat-chip-row>
        <input [matChipInputFor]="chipGrid" disabled />
    </mat-chip-grid>
</mat-form-field>

<ng-template #addColleagueDialog>
    <h1 mat-dialog-title>Colleague Details</h1>
    <div mat-dialog-content>
        <div class="p-t-20 field-column">
            <mat-form-field appearance="outline" class="full-width">
                <mat-label>Title</mat-label>
                <mat-select [(ngModel)]="addingColleague.title" required>
                    <mat-option *ngFor="let title of titles" [value]="title.value">
                        {{ title.text }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline" class="full-width">
                <mat-label>Name</mat-label>
                <input matInput [(ngModel)]="addingColleague.name" placeholder="Name" type="text" required>
            </mat-form-field>
            <mat-form-field appearance="outline" class="full-width">
                <mat-label>Surname</mat-label>
                <input matInput [(ngModel)]="addingColleague.surname" placeholder="Surname" type="text" required>
            </mat-form-field>
            <mat-form-field appearance="outline" class="full-width">
                <mat-label>Speciality</mat-label>
                <mat-select [(ngModel)]="addingColleague.speciality">
                    <mat-option *ngFor="let speciality of specialities" [value]="speciality.value">
                        {{ speciality.text }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline" class="full-width">
                <mat-label>Email</mat-label>
                <input matInput [(ngModel)]="addingColleague.email" placeholder="Email" type="email" required>
            </mat-form-field>
            <app-intl-phone-input [preferredCountries]="['za']" [providedValue]="addingColleague.contactNumber"
                placeholder="Contact Number" (valueChange)="addingColleague.contactNumber = $event" name="contactNumber"
                classList="full-width"></app-intl-phone-input>
        </div>
    </div>
    <div mat-dialog-actions class="dialog-actions">
        <button mat-raised-button color="primary" [mat-dialog-close]="addingColleague">Save</button>
    </div>

</ng-template>